import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ComplianceAlert = ({ alerts, onDismiss, onViewAll }) => {
  const getAlertIcon = (type) => {
    switch (type) {
      case 'deadline': return 'Clock';
      case 'error': return 'AlertTriangle';
      case 'warning': return 'AlertCircle';
      case 'info': return 'Info';
      default: return 'Bell';
    }
  };

  const getAlertColor = (type) => {
    switch (type) {
      case 'deadline': return 'border-l-warning bg-warning/5';
      case 'error': return 'border-l-error bg-error/5';
      case 'warning': return 'border-l-warning bg-warning/5';
      case 'info': return 'border-l-primary bg-primary/5';
      default: return 'border-l-muted bg-muted/5';
    }
  };

  if (!alerts || alerts?.length === 0) return null;

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground flex items-center">
          <Icon name="AlertTriangle" size={20} className="mr-2 text-warning" />
          Compliance Alerts
        </h3>
        <Button variant="ghost" size="sm" onClick={onViewAll}>
          View All
        </Button>
      </div>
      <div className="space-y-3">
        {alerts?.slice(0, 3)?.map((alert) => (
          <div
            key={alert?.id}
            className={`border-l-4 p-4 rounded-r-lg ${getAlertColor(alert?.type)}`}
          >
            <div className="flex items-start justify-between">
              <div className="flex items-start space-x-3">
                <Icon 
                  name={getAlertIcon(alert?.type)} 
                  size={16} 
                  className={`mt-0.5 ${
                    alert?.type === 'error' ? 'text-error' :
                    alert?.type === 'warning' || alert?.type === 'deadline' ? 'text-warning' :
                    alert?.type === 'info' ? 'text-primary' : 'text-muted-foreground'
                  }`}
                />
                <div className="flex-1">
                  <p className="font-medium text-foreground text-sm">{alert?.title}</p>
                  <p className="text-sm text-muted-foreground mt-1">{alert?.message}</p>
                  {alert?.dueDate && (
                    <p className="text-xs text-muted-foreground mt-2">
                      Due: {new Date(alert.dueDate)?.toLocaleDateString()}
                    </p>
                  )}
                </div>
              </div>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => onDismiss(alert?.id)}
                className="h-6 w-6"
              >
                <Icon name="X" size={12} />
              </Button>
            </div>
          </div>
        ))}
      </div>
      {alerts?.length > 3 && (
        <div className="mt-4 text-center">
          <Button variant="ghost" size="sm" onClick={onViewAll}>
            View {alerts?.length - 3} more alerts
          </Button>
        </div>
      )}
    </div>
  );
};

export default ComplianceAlert;